

export const constant = {

    CONTEXTUAL_HELP_FETCH_IN_PROGRESS: "CONTEXTUAL_HELP_FETCH_IN_PROGRESS",
    CONTEXTUAL_HELP_FETCH_COMPLETE: "CONTEXTUAL_HELP_FETCH_COMPLETE",
}